import { useState, useEffect } from 'react';

export default function useLocalStorage(key: string, initialValue: any) {
  const [value, setValue] = useState(() => {
    // Check if we're in the browser (not SSR)
    if (typeof window === 'undefined') {
      return initialValue;
    }

    const jsonValue = localStorage.getItem(key);
    if (jsonValue != null) return JSON.parse(jsonValue);
    return initialValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
